import React from 'react';

export const NPM: React.FC = () => {
    return (
        <svg
            viewBox='0 0 67 66'
            fill='#fff'
            fillRule='evenodd'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            width='24'
            height='24'
            className='npm'
        >
            <use xlinkHref='#A' x='1' y='1' />
            <symbol id='A' overflow='visible'>
                <g stroke='none' fillRule='nonzero'>
                    <path d='M0 0h64v64H0z' fill='#cb3837' />
                    <path d='M10.728 53.272h21.086V21.456h10.728v31.816H53.27V10.728H10.728z' />
                </g>
            </symbol>
        </svg>
    );
};
